import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";

export interface SeasonOption {
  value: number;
  label: string;
  icon?: string;
}

export interface IGameForm {
  datetime: Date;
  location: string;
  notes: string;
  opponentTeam?: string;
  playAs?: string;
  seasonId?: string;
}

export enum GameType {
  TRAINING = "TRAINING",
  COMPETITIVE = "COMPETITIVE",
  ORGANIZATION_MATCH = "ORGANIZATION_MATCH",
}

export const newGameForm = (gameType: GameType): FormBuilderType<IGameForm> => {
  if (gameType === GameType.TRAINING) {
    return {
      datetime: {
        type: "date",
        name: "datetime",
        label: "Date",
        validators: [FormBuilderValidator.required()],
        required: true,
        props: {
          mode: "datetime",
        },
      },
      location: {
        type: "input",
        name: "location",
        label: "Location",
        defaultValue: "",
        validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
        required: true,
      },
      notes: {
        type: "input",
        name: "notes",
        label: "Notes",
        defaultValue: "",
        validators: [],
        required: false,
      },
    };
  } else {
    return {
      datetime: {
        type: "date",
        name: "datetime",
        label: "Date",
        validators: [FormBuilderValidator.required()],
        required: true,
        props: {
          mode: "datetime",
        },
      },
      location: {
        type: "input",
        name: "location",
        label: "Location",
        defaultValue: "",
        validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
        required: true,
      },
      notes: {
        type: "input",
        name: "notes",
        label: "Notes",
        defaultValue: "",
        validators: [],
        required: false,
      },
      opponentTeam: {
        type: "input",
        name: "opponentTeam",
        label: "Opponent Team",
        defaultValue: "",
        validators: [FormBuilderValidator.required()],
        required: true,
      },
      playAs: {
        type: "radio",
        name: "playAs",
        label: "Playing As",
        defaultValue: "",
        validators: [FormBuilderValidator.required()],
        required: true,
        options: [
          { label: "Host", value: "host" },
          { label: "Guest", value: "guest" },
        ],
      },
    };
  }
};

export const gameTypeOptions = [
  { label: "Training", value: GameType.TRAINING },
  { label: "Competitive", value: GameType.COMPETITIVE },
];

export const getGameTypeExplainer = (gameType: GameType): string => {
  switch (gameType) {
    case GameType.TRAINING:
      return "This is a casual match within your own group. You gather, then split everyone into two teams and enjoy the game.";
    case GameType.COMPETITIVE:
      return "This is an official or semi-official match against another team. Typically part of a local league, tournament, or friendly versus another group. The opponent is an external team (e.g., another amateur club or futsal league team).";
    default:
      return "";
  }
};
